import { NavLink } from 'react-router-dom';
import {
  LayoutGrid,
  BarChart3,
  AlertTriangle,
  Calendar,
  Users,
  FileText,
} from 'lucide-react';

const navItems = [
  { to: '/', label: 'Projects', icon: LayoutGrid },
  { to: '/capacity', label: 'Capacity', icon: BarChart3 },
  { to: '/at-risk', label: 'At Risk', icon: AlertTriangle },
  { to: '/reports', label: 'Reports', icon: FileText },
  { to: '/timeline', label: 'Timeline', icon: Calendar },
  { to: '/resources', label: 'Resources', icon: Users },
];

export function Sidebar() {
  return (
    <aside className="w-56 border-r border-border p-4 hidden lg:block bg-background-subtle">
      <nav className="space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-foreground-muted hover:bg-background-muted hover:text-foreground'
              }`
            }
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
